// Static route table for the area; pages load lazily (one chunk + its CSS).
// Tabs keep react-admin's index paths (`/tenants/:id/1`, `/tenants/:id/show/2`,
// PARITY Q24). The tab is an OPTIONAL segment of one route, so switching tabs
// keeps the page (and the form state) mounted, as TabbedForm does.
import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/tenants/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const tenantsRoutes: RouteObject[] = [
  {
    path: 'tenants',
    handle: crumb('Tenants'),
    children: [
      { index: true, lazy: page('TenantListPage') },
      { path: 'create', handle: crumb('Create'), lazy: page('TenantCreatePage') },
      {
        path: ':id',
        handle: { crumb: (match) => match.params.id ?? null } satisfies CrumbHandle,
        children: [
          { path: 'show/:tab?', handle: crumb('Show'), lazy: page('TenantShowPage') },
          { path: ':tab?', lazy: page('TenantEditPage') }
        ]
      }
    ]
  }
]
